import { render, staticRenderFns } from "./ColonySpace.vue?vue&type=template&id=39cb1b8f"
import script from "./ColonySpace.vue?vue&type=script&lang=ts"
export * from "./ColonySpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports